export default __webpack_public_path__ + "static/media/collection-1.85f53d8c.png";